<template>
    <div class="yesno">
        <p>{{ question }}</p>
        <validation-provider rules="required"
                             v-slot="{ errors, classes }"
                             tag="div"
        >
            <div class="wrap">
                <uni-input-radio :id="name+'Yes'"
                                 label="Oui"
                >
                    <input type="radio" v-model="val" value="yes" @input="$emit('input', true)" :id="name+'Yes'">
                </uni-input-radio>
                <uni-input-radio :id="name+'No'"
                                 label="Non"
                >
                    <input type="radio" v-model="val" value="no" @input="$emit('input', false)" :id="name+'No'">
                </uni-input-radio>
            </div>
            <span>{{ errors[0] }}</span>
        </validation-provider>
        <div v-if="message" class="card">
            {{ message }}
        </div>
    </div>
</template>

<script>
    import UniInputRadio from "./UniInputRadio";
    export default {
        name: "RichYesNoInput",
        components: {UniInputRadio},
        props:{
            question: String,
            message: String,
            name: String
        },
        data(){
            return{
                val: null,
            }
        }
    }
</script>

<style scoped lang="scss">
.wrap{
    display:flex;
    >*:first-child{
        margin-right: 16px;
    }
}
.yesno{
    margin-bottom: 16px;
}
.card{
    margin-bottom: 16px;
}
span{
    color: var(--color-warning-dark);
}
</style>
